<script>
import { mapGetters, mapActions } from 'vuex'
import Layout from '@layouts/main.vue'
import Bill from '@components/bill.vue'
import BillSummary from '@components/bill-summary.vue'

export default {
  page: {
    title: 'Payment',
    meta: [{ name: 'description', content: 'The Payment page.' }],
  },
  components: { Layout, Bill, BillSummary },
  computed: {
    ...mapGetters({
      accountId: 'payment/getAccountId',
      content: 'contentful/getContent',
      emailAddress: 'payment/getEmailAddress',
      items: 'payment/getItems',
      location: 'location/getLocation',
      selectedTotal: 'payment/getSelectedTotal',
      selectedItems: 'payment/getSelectedItems',
      serviceCharge: 'payment/getServiceCharge',
      splitBill: 'payment/getSplitBill',
      splitServiceCharge: 'payment/getSplitServiceCharge',
      tableNumber: 'payment/getTableNumber',
      tip: 'payment/getTip',
      total: 'payment/getTotal',
    }),
    computedParams() {
      /**
       * locationId (lowercase ‘L’): the Aztec site ID
       * dateTime: the date-time, In the format YYYY-MM-DD HH:II, URL-encoded
       * checkId: The Aztec AccountId
       */
      const now = new Date().toISOString()
      return this.buildUrlQuery({
        locationId: this.siteId,
        dateTime: `${now.substr(0, 10)} ${now.substr(11, 5)}`,
        checkId: this.accountId,
      })
    },
    siteId() {
      return this.location && this.location.siteId
        ? parseFloat(this.location.siteId)
        : 0
    },
  },
  beforeMount() {
    this.checkForData()
  },
  methods: {
    ...mapActions({
      checkForData: 'payment/checkForData',
    }),
    buildUrlQuery(data) {
      return Object.entries(data)
        .map((pair) => pair.map(encodeURIComponent).join('='))
        .join('&')
    },
  },
}
</script>

<template>
  <Layout v-if="items" screen="payment">
    <div class="content">
      <div>
        <h1 :class="$style.padding" v-text="'Your payment was successful'" />
        <p
          ref="description"
          class="pre-line"
          v-text="`We have emailed your receipt to ${emailAddress}`"
        />
        <BillSummary
          :amount="items && items.length"
          :order-number="accountId"
          :selected-total="selectedTotal"
          :selected-items="selectedItems"
          :service-charge="serviceCharge"
          :split-service-charge="splitServiceCharge"
          :table-number="tableNumber"
          :tip="tip"
          :total="total"
        />
        <Bill
          :collapsable="true"
          :items="items"
          :selected-items="selectedItems"
          :selected-total="selectedTotal"
          :service-charge="serviceCharge"
          :split-bill="splitBill"
          :split-service-charge="splitServiceCharge"
          :tip="tip"
          :title="'Your Order'"
          :total="total"
        />
      </div>
      <div :class="$style.padding" class="footer">
        <BaseLink :href="`${content.feedbackUrl}?${computedParams}`">
          <BaseButton v-text="'Leave Feedback'" />
        </BaseLink>
        <div :class="$style.spacer">
          <BaseLink :href="content.termsConditionsUrl">
            Terms & Conditions
          </BaseLink>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.container {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 3rem 0 1.5rem;
  text-align: center;

  > * {
    width: 100%;
  }
}

.padding {
  padding: 2rem 0;
}

.spacer {
  margin: 20px 0;
}
</style>
